import { singleton, inject } from "tsyringe";

// shared
import type { HttpAdapter } from "@/shared/libs/http/interface";

// domain
import type {
    CommonAccountsRepository,
    RequestPostUserLoginPayload,
} from "@/entities/common/interface/common-accounts/domain/repository";
import type { SignInResponseDto } from "@/entities/common/interface/common-accounts/domain/dtos";

@singleton()
export default class CommonAccountsRepositoryImpl implements CommonAccountsRepository {
    constructor(@inject("HttpAdapter") private readonly server: HttpAdapter) {}

    /**
     * @description 유저 로그인
     * @param {RequestPostUserLoginPayload} payload
     */
    public postUserLogin = async (payload: RequestPostUserLoginPayload) => {
        const response = await this.server.post<SignInResponseDto>(`/v2/sign-in`, payload);

        return response;
    };

    /**
     * @description 유저 로그아웃
     */
    public postUserLogout = async () => {
        await this.server.post(`/v2/sign-out`);
    };
}
